import Nullstack from 'nullstack';
export default function IconAlarmOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-alarm-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7.587 7.566a7 7 0 1 0 9.833 9.864m1.35 -2.645a7 7 0 0 0 -8.536 -8.56"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v1h1"
  }), "   ", Nullstack.element("path", {
    d: "M5.261 5.265l-1.011 .735"
  }), "   ", Nullstack.element("path", {
    d: "M17 4l2.75 2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}